import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bibFieldShape, userIdentityShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import Details from './Details';

export class DetailsContainer extends React.PureComponent {
  render() {
    return <Details {...this.props} />;
  }
}

DetailsContainer.propTypes = {
  fields: ImmutablePropTypes.mapContains({
    category: PropTypes.string.isRequired,
    items: ImmutablePropTypes.listOf(bibFieldShape).isRequired
  }),
  currentUser: userIdentityShape,
  catalogBib: catalogBibShape.isRequired
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  return {
    fields: catalogBib.get('fields').find(fieldSet => fieldSet.get('category') === 'ABOUT'),
    currentUser: selectCurrentUser(state),
    catalogBib
  };
};

export default connect(mapStateToProps)(DetailsContainer);
